import AppsOutlinedIcon from '@mui/icons-material/AppsOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import SearchIcon from '@mui/icons-material/Search';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import type { SvgIconComponent } from '@mui/icons-material';

const navigationIconComponents: Record<string, SvgIconComponent> = {
  search: SearchIcon,
  notifications: NotificationsOutlinedIcon,
  timeline: TimelineOutlinedIcon,
  description: DescriptionOutlinedIcon,
  folder: FolderOutlinedIcon,
  apps: AppsOutlinedIcon,
};

export function resolveNavigationIcon(icon?: string): SvgIconComponent {
  if (!icon) {
    return AppsOutlinedIcon;
  }

  return navigationIconComponents[icon] ?? AppsOutlinedIcon;
}

export function resolveNodeLabel(
  label: string,
  translate: (key: string, options?: { defaultValue?: string }) => string,
): string {
  if (label.startsWith('navigationConfig.')) {
    return translate(label, { defaultValue: label });
  }

  return label;
}
